/**
 * Le schede dell'amministrazione (GI-279).
 *
 * Erano cinque pagine — utenti, modello, impostazioni, catalogo, registro —
 * senza un collegamento fra loro: la barra portava alla prima, le altre si
 * raggiungevano solo scrivendo l'indirizzo. Piu' «Esercizio», un modulo a
 * parte con una schermata sola. Ora sono le schede di un modulo unico, con
 * lo stesso vestito delle schede della commessa: chi ha imparato quelle
 * riconosce queste.
 *
 * Filtrate da `Whoami.may`: una scheda che porta a un rifiuto e' peggio di
 * una scheda che non c'e'.
 */
import { NavLink } from 'react-router-dom'

import {
  AUDIT_READ,
  CATALOG_IMPORT,
  MODEL_MANAGE,
  SETTINGS_MANAGE,
  USER_MANAGE,
  type Whoami,
} from '../auth'
import { useT } from '../i18n/LocaleProvider'
import type { MessageKey } from '../i18n/messages'

const TABS: { to: string; name: MessageKey; need: string }[] = [
  { to: '/admin/users', name: 'title.users', need: USER_MANAGE },
  { to: '/admin/model', name: 'title.model', need: MODEL_MANAGE },
  { to: '/admin/settings', name: 'title.settings', need: SETTINGS_MANAGE },
  { to: '/admin/catalog', name: 'title.catalog', need: CATALOG_IMPORT },
  { to: '/admin/audit', name: 'title.audit', need: AUDIT_READ },
  { to: '/operations', name: 'title.operations', need: SETTINGS_MANAGE },
]

/** Se l'indirizzo sta dentro il modulo dell'amministrazione. */
export function isAdminScreen(pathname: string): boolean {
  return pathname.startsWith('/admin') || pathname.startsWith('/operations')
}

export function AdminTabs({ who }: { who: Whoami }): JSX.Element {
  const t = useT()
  return (
    <nav className="workspace-tabs workspace-tabs-admin" aria-label={t('nav.adminSections')}>
      {/* Il nome del modulo davanti alle sue schede: la testa non ha piu' un
          titolo grande, e' la scheda accesa a dire dove si e'. */}
      <span className="workspace-modulo">{t('rail.admin')}</span>
      {TABS.filter((one) => who.may.includes(one.need)).map((one) => (
        <NavLink
          key={one.to}
          to={one.to}
          className={({ isActive }) => (isActive ? 'workspace-tab on' : 'workspace-tab')}
        >
          {t(one.name)}
        </NavLink>
      ))}
    </nav>
  )
}
